import Vue from "vue";
import { getCookie } from "../../../../ask/cookiejs";
import { post, fetch, Del, put } from "../../../../ask/axios";
import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue';

export default {
  components: {menberMenu,},
  data (){
    return {
      api: {
        url: "",
        param: "",
        data:"",
        response: {},
        message: ""
      },

      titNames: 'My Info,My advice',
      titUrls: ',',
      myHeaders: {
        ['X-JWT-TOKEN']: getCookie('JWT-TOKEN')
      },

   //------------委托书列表内容 --------------//
   adviceList:[],
   ReplyFlag:2, //回复筛选

   SugType:1,//SugType建议类型。1：系统功能，2：百运服务，3：我要投诉，4：其他


   //提建议弹框
   adviceBox:false,
   adviceText:'',//建议
   isText:false,
   adviceMsg:'',

     ////分页
     currentPage:1, //当前页数
     pageSize:20, //，每页显示的条数
     total: 0, //查询结果条数

    }
  },
  created(){ //创建后
   this.getAdviceApi();
  },
  mounted(){ //载入dom后周期函数
    
  },
  watch:{//监听函数变化

  },
  computed:{//计算属性
    
   },

   //方法
  methods: {
      //分页按钮
      handleSizeChange(val) {
        this.pageSize=val
        this.getAdviceApi()
     },
     handleCurrentChange(val) {
       this.currentPage = val;
       this.getAdviceApi()
     },
      
    //查询委托书列表接口
    getAdviceApi(){
      let that=this;
      let FlagVal=null
      if(this.ReplyFlag==2){
        FlagVal=null
      }else{
        FlagVal=this.ReplyFlag
      }
      this.api.param={
        ReplyFlag:FlagVal,
        Skip:(this.currentPage - 1) * this.pageSize,
        Take:this.pageSize,
      };
      // this.api.url=this.$api02+"/api/EbayCustomer/CustomerSuggest/QueryPaging"
      this.api.url=this.$api04 + "/Basics/api/CustomerSuggest/QueryPaging"
      post(this.api.url,this.api.param).then(function (res) {
        if(res.IsOK==true){
          that.adviceList = res.Results
          that.total=res.Total
        }
      })
    },
     //筛选回复状态
    clkReplyFlag(val){
      this.ReplyFlag=val 
      this.getAdviceApi()
    },  
    //----------------弹框--------------------------///
    //点击提建议按钮
    clkAdvice(){
      this.adviceBox=true
    },

    clkSugType(val){
      this.SugType=val
    },
     //新增我要吐槽接口
    addAdviceApi(){
      let that=this;
     //SugType建议类型。1：系统功能，2：百运服务，3：我要投诉，4：其他
      this.api.param={
        SugType:this.SugType,
        SuggestContent:this.adviceText,
      };
      // this.api.url=this.$api02+"/api/EbayCustomer/CustomerSuggest/Add"
      this.api.url=this.$api04 + "/Basics/api/CustomerSuggest/Add"
      post(this.api.url,this.api.param).then(function (res) {
        if(res.IsOK==true){
         // that.getAdviceApi(); //刷新列表
          that.adviceBox=false
            that.$confirm( 'The submission was successful. Thank you for your Suggestions to freightshop!','',  {
              customClass:'custom-message-box', //自定义添加Class
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
              closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
              showCancelButton:false,//去掉取消按钮
              showClose:false,//去掉右上角的取消（X）
              // type: 'warning',
              center: true
            }).then(() => {
              that.getAdviceApi(); //刷新列表
            }).catch(() => {
    
            });
            return false
        }
      })
    },
    //验证建议是否超过500字符
    blurText(){
      let isTrue=true
      if(!this.adviceText){
        this.adviceMsg='Required'
        this.isText=true
        isTrue=false
      }else if(this.adviceText.length > 500){
        this.adviceMsg='Maximum is 500 characters'
        this.isText=true
        isTrue=false
      }else{
        this.adviceMsg=''
        this.isText=false
        isTrue=true
      }
      return isTrue
    },
    
    //关闭弹框按钮
    clkClose(){
      this.adviceBox=false
      this.adviceText=''
      this.SugType=1
    
    },
    //弹框确定按钮
    clkSureBtn(){
       //console.log('this.isText  '+  this.isText);
       //console.log('this.isText  '+ this.blurText());
       if(!this.blurText()){
        return false
       }
       this.addAdviceApi()
    },
    //转换建议类型
    judSugType(val){
      if(val==1) return 'About systems';
      if(val==2) return 'About service';
      if(val==3) return 'Complaints';
      if(val==4) return 'Others';
    }
    

  }
  }


// WEBPACK FOOTER //
// ./src/assets/js/userCenter/myInfo/myAdvice.js